import { CheckCircleIcon } from '@heroicons/react/24/solid'

interface Props {
  text: string
  title: string
}

export default function BulletPoint({ text, title }: Props) {
  return (
    <div className="flex items-start gap-4">
      <CheckCircleIcon className="custom-bullet-point h-8 w-8 shrink-0" />

      <div>
        <p className="font-bold">{title}</p>

        <p>{text}</p>
      </div>
    </div>
  )
}
